module.exports = __webpack_public_path__ + "static/media/28.e6015939.png";